if( $('#pagina-simulados').length ) {

    var vmSimulados = new Vue({
        el: '#pagina-simulados',
        data: {

            logado                  : false,
            anos                    : [],
            areasConhecimento       : {},
            areasSelecionadas       : [],
            passoAtual              : 1,
            modificouAreas          : true,
            modificouDisciplinas    : true,
            disciplinasSelecionadas : [],
            questoesDisponiveis     : 0,

            excluiResolvidas        : true,
            arvore                  : {},

            numQuestoes             : 0,
            tempoMedioPorQuestao    : 3, /*min*/
            timerH                  : 0,
            timerM                  : 0,
            timerS                  : 0,

            timerIniciado           : false,
            timerPausado            : false,
            timerZerado             : false,
            falta5min               : false,
            animandoTimer           : false,
            ultimaAcao              : '',

            modoSimulado            : false,
            questoesCarregadas      : false,
            simuladoIniciado        : false,
            indiceAberto            : false,

            questoes                : {},
            questaoAtual            : 1,
            numResolvidas           : 0,
            tempoQuestao            : 0, /* tempo gasto em cada questão */

            simuladoFinalizado      : false,
            numAcertos              : 0,
            tempoMedioGasto         : 0,
            mostrandoResultados     : false,
            resultadoSelecionado    : -1,
            salvarNaSaida           : 'sim',

            fs : {
                current     : null,
                next        : null,
                previous    : null,
                animating   : false
            },

            lightbox            : lity(),
            suspendeWatchs      : false,
            dadosDesempenho   : {
                labels: [
                    "Acerto",
                    "Erro"
                ],
                datasets: [{
                    data: [ ],
                    backgroundColor: [
                        "rgba(25, 196, 9, 1)",
                        "rgba(234, 9, 13, 1)"
                    ],
                    hoverBackgroundColor: [
                        "rgba(25, 196, 9, 0.8)",
                        "rgba(234, 9, 13, 0.8)"
                    ]
                }]
            },
            dadosTempo :  {
                labels: [],
                datasets: [
                    {
                        backgroundColor: "rgba(128,159,255,0.4)",
                        borderColor: "rgba(128,159,255,1)",
                        borderWidth: 1,
                        hoverBackgroundColor: "rgba(128,159,255,0.8)",
                        hoverBorderColor: "rgba(128,159,255,1)",
                        data: []
                    }
                ]
            },
            filtros : {

                desde                   : -1,
                ate                     : -1,
                excluirResolvidas       : false,
                excluirDesatualizadas   : false

            }
        },
        methods: {
            timerTick: function () {

                if( this.timerPausado || this.timerZerado ) return;

                if( this.timerH == 0 && this.timerM == 1 && this.timerS == 0 ){
                    flash('Corra! Resta só 1 minuto!', 'atencao');
                }

                if( this.timerH == 0 && this.timerM <= 4 && !this.falta5min ){
                    this.timer('mostrar');
                    this.falta5min = true;
                    flash('Restam apenas 5 minutos!', 'atencao');
                }

                this.tempoQuestao++;

                if( this.timerS > 0 ){
                    return this.timerS--;
                }

                if( this.timerM > 0 ){
                    this.timerS = 59;
                    return this.timerM--;
                }

                if( this.timerH > 0 ){
                    this.timerS = 59;
                    this.timerM = 59;
                    return this.timerH--;
                }

                this.timerZerado = true;
                this.finalizaSimulado( this.timerZerado );
            },
            toggleArea: function ( area ) {
                area.selecionado = !area.selecionado;

                this.passoUmAlterado();
            },
            toggleDisciplina: function ( disciplina ) {
                disciplina.selecionado = !disciplina.selecionado;

                // força recalcular dados do passo 3.
                this.modificouDisciplinas = true;
            },
            toggleExcluirResolvidas: function () {
                this.excluiResolvidas = !this.excluiResolvidas;
                this.passoUmAlterado();
            },
            verificaNumQuestoes: function () {

                if( this.numQuestoes > Math.min(this.questoesDisponiveis, 50) ){
                    if( this.questoesDisponiveis < 50 ){
                        this.numQuestoes = this.questoesDisponiveis;
                        flash('Segundo seus filtros só há ' + this.questoesDisponiveis + ' questões disponiveis', 'erro');
                    }else{
                        this.numQuestoes = 50;
                        flash('Seu simulado deve ter no máximo 50 questões', 'erro');
                    }

                }

                if( this.numQuestoes < 10 ){
                    this.numQuestoes = 10;
                    flash('Seu simulado deve ter no mínimo 10 questões', 'erro');
                }

                this.defineTempo();
            },
            verificaMinutos: function () {
                if( this.timerM > 59 ){
                    return this.timerM = 59;
                }
            },
            defineTempo: function () {

                var minutos = this.numQuestoes * this.tempoMedioPorQuestao;
                this.timerH = Math.min(Math.floor(minutos/60), 99); // só dois dígitos
                this.timerM = minutos % 60;
            },
            passoUmAlterado: function () {
                // força recarregar disciplinas no passo 2.
                this.modificouAreas = true;
            },
            faltaRequisitos: function () {

                // var requisitos = false;
                var requisitos = true;
                var msgErro = [];

                switch( this.passoAtual ){
                    case 1:
                        requisitos = this.areasSelecionadas.length > 0;
                        if( !requisitos ){
                            msgErro.push('Selecione pelo menos uma Área de Conhecimento');
                        }
                        if( (this.filtros.desde == -1) || (this.filtros.ate == -1) ){
                            msgErro.push('Selecione o ano inicial e final');
                        }
                        requisitos = requisitos && (this.filtros.desde != -1) && (this.filtros.ate != -1);

                        break;
                    case 2:
                        requisitos = this.questoesDisponiveis >= 10;
                        if( !requisitos ){
                            msgErro.push('Selecione mais disciplinas, para somar no mínimo 10 questões.');
                        }
                }

                return requisitos ? false : msgErro;
            },
            setArvore: function (dados) {
                this.arvore = dados.arvore;
                this.questoesDisponiveis = dados.questoesDisponiveis;
            },
            next: function( ){

                var self = this, msg;

                if( ! this.logado  ){
                    return nav.open('register');
                }

                // Falta algum dado pro próximo passo?
                if( msg = this.faltaRequisitos() ){
                    for(var m in msg){
                        flash(msg[m], 'erro');
                    }
                    location.hash = '#passo' + this.passoAtual;
                    return false;
                }

                // Tratamentos: Passo 1 -> Passo 2
                if( this.passoAtual == 1 ){
                    if( this.modificouAreas ){

                        ajaxGET(
                            '/simulados/carrega-disciplinas',
                            {
                                areas           : this.areasSelecionadas,
                                desde           : this.filtros.desde,
                                ate             : this.filtros.ate,
                                excluiResolvidas: this.excluiResolvidas
                            },
                            this.setArvore
                        );
                    }

                    this.modificouAreas = false;
                }

                // Tratamentos: Passo 2 -> Passo 3
                if( this.passoAtual == 2 ){
                    if( this.modificouDisciplinas ){
                        this.numQuestoes = (this.questoesDisponiveis >= 30) ? 30 : 10;
                        this.defineTempo();
                    }

                    this.modificouDisciplinas = false;
                }

                self.animacaoNext();
                self.passoAtual++;
                location.hash = '#passo' + self.passoAtual;
            },
            animacaoNext: function () {
                var self = this;
                var scale, left, opacity;

                scrollToTop(400);
                this.fs.current = $('#passo-' + self.passoAtual );
                this.fs.next = $('#passo-' + (self.passoAtual+1) );

                if(this.fs.animating) return false;
                this.fs.animating = true;

                // atualiza o progressbar
                $("#progressbar li").eq($("fieldset").index(self.fs.next)).addClass("active");

                //mostra o proximo fieldset
                this.fs.next.show();

                // esconde fieldset atual com efeito
                this.fs.current.animate({opacity: 0}, {
                    step: function(now, mx) {
                        scale = 1 - (1 - now) * 0.2;
                        left = (now * 50)+"%";
                        opacity = 1 - now;
                        self.fs.current.css({
                            'transform': 'scale(' + scale + ')',
                            'position': 'absolute'
                        });
                        self.fs.next.css({'left': left, 'opacity': opacity});
                    },
                    duration: 800,
                    complete: function(){
                        self.fs.current.hide();
                        self.fs.animating = false;
                    },
                    // isso vem do easing plugin
                    easing: 'easeInOutBack'
                });
            },
            prev: function () {

                var self = this;
                var scale, left, opacity;

                scrollToTop(400);
                this.fs.current = $('#passo-' + self.passoAtual );
                this.fs.previous = $('#passo-' + (self.passoAtual-1) );

                if(this.fs.animating) return false;
                this.fs.animating = true;

                // volta um passo no progressbar
                $("#progressbar li").eq($("fieldset").index(this.fs.current)).removeClass("active");

                this.fs.previous.show();

                // esconde o fieldset atual, com animacao
                this.fs.current.animate({opacity: 0}, {
                    step: function(now, mx) {
                        scale = 0.8 + (1 - now) * 0.2;
                        left = ((1-now) * 50)+"%";
                        opacity = 1 - now;
                        self.fs.current.css({'left': left});
                        self.fs.previous.css({'transform': 'scale('+scale+')', 'opacity': opacity});
                    },
                    duration: 800,
                    complete: function(){
                        self.fs.current.hide();
                        self.fs.animating = false;
                    },
                    easing: 'easeInOutBack'
                });

                this.passoAtual--;
                location.hash = '#passo' + this.passoAtual;
            },
            relatarProblema: function ( prova_id ){

                if( ! this.logado  ){
                    return nav.open('register');
                }

                fechaTooltips();

                vmRelatarProblema.problemas = this.reportarProblema;
                vmRelatarProblema.urlAjax = '/provas/relatar-problema';
                vmRelatarProblema.abrirModal( prova_id );
            },
            carregaQuestoes: function (dadosAjax) {

                var self = this;
                this.suspendeWatchs = true;

                ajaxGET(
                    '/provas/filtrar',
                    dadosAjax,
                    function (dadosRetorno) {
                        self.sincronizaModelComServer(dadosRetorno);
                    }
                );

            },
            gerarSimulado: function ( prova_id ) {

                /* Até o momento eu ignoro essa mudança no hash */
                location.hash = '#modo-simulado';

               if( prova_id ){
                   ajaxGET('/simulados/carrega-questoes-da-prova', { provaId: prova_id }, this.setQuestoes);
               }else{
                   ajaxGET(
                       '/simulados/carrega-questoes',
                       {
                           disciplinas     : this.disciplinasSelecionadas,
                           desde           : this.filtros.desde,
                           ate             : this.filtros.ate,
                           excluiResolvidas: this.excluiResolvidas,
                           numQuestoes     : this.numQuestoes
                       },
                       this.setQuestoes
                   );
               }

                this.entrarModoSimulado();
            },
            setQuestoes: function ( dados ) {

                this.questoes = dados.questoes;
                this.numQuestoes = dados.numQuestoes;

                /* Caso o timer não tenha sido definido.
                 * Caso de resolver uma prova em específico.
                */
                if( (this.timerH == 0) && (this.timerM == 0) ){
                    var tempoM = this.numQuestoes * this.tempoMedioPorQuestao;
                    if( tempoM > 59 ){
                        this.timerH = Math.floor(tempoM/60);
                        this.timerM = tempoM%60;
                    }else{
                        this.timerM = tempoM;
                    }
                }

                this.questoesCarregadas = true;
            },
            entrarModoSimulado: function () {

                this.modoSimulado = true;
                location.hash = '#modo-simulado';

                Vue.nextTick(function () {

                    var janela = $('#janela-simulado');

                    janela.animate({
                        height: "100%",
                        top: "0",
                        opacity: "0.4"
                    }, 300, function(){
                        janela.animate({
                            width: "100%",
                            left: "0"
                        }, 300, function () {
                            janela.animate({
                                opacity: "1"
                            }, 800, function () {
                                $('div.vamos-comecar').fadeIn(800);
                                $('html').css('background-color', '#333333');
                                $('#menu-superior-total').hide();
                            });
                        });
                    });

                });

            },
            sairModoSimulado: function ( ) {

                var self = this;

                $('div.vamos-comecar').fadeOut(400, function () {
                    self.animaSaidaSimulado();
                });

            },
            animaSaidaSimulado: function () {

                var janela = $('#janela-simulado');
                var self = this;

                $('html').css('background-color', 'transparent');
                $('#menu-superior-total').show();

                janela.animate({
                    width: "0",
                    left: "50%",
                    opacity: "0.5"
                }, 300, function(){
                    janela.animate({
                        height: "0",
                        top: "50%",
                        opacity: "0"
                    }, 300, function () {
                        if( self.simuladoIniciado ){
                            // pra garantir todas variaveis reiniciadas, melhor redirecionar.
                            return window.location.replace('/simulados');
                        }
                    });
                });
            },
            timer: function ( acao, delay_ms ) {

                this.ultimaAcao = acao;

                /* Nos  últimos 5min o timer fica sempre visível */
                if( !this.falta5min && !this.animandoTimer ) {

                    this.animandoTimer = true;

                    var self = this;
                    var margin = (acao == 'mostrar') ? -40 : 0;
                    var icone = $('#icone-relogio');

                    if( delay_ms ){
                        icone = icone.delay(delay_ms);
                    }

                    icone.animate({
                        marginTop: margin
                    }, 500, function () {
                        self.animandoTimer = false;
                        if( self.ultimaAcao != acao ){
                            self.timer( self.ultimaAcao );
                        }
                    });
                }
            },
            iniciarSimulado: function () {

                var self = this;
                this.simuladoIniciado = true;
                this.timerPausado = false;

                this.timerS = 0;

                if( !this.timerIniciado ){
                    this.iniciaTimer();
                }

                /* Só depois que atualizar o DOM */
                Vue.nextTick(function () {
                    self.animandoTimer = true;
                    $('#icone-relogio').animate(
                        { marginTop: -40 },
                        800,
                        function () {
                            self.animandoTimer = false;
                            self.timer('esconder', 5000);
                        }
                    );
                    inicializaTooltips();
                    self.mathJaxRender();
                });
            },
            iniciaTimer: function () {
                var self = this;
                this.timerIniciado = true;
                setInterval(self.timerTick, 1000);
            },
            sair: function () {
                var self = this;
                confirma({
                    titulo  : 'Deseja mesmo sair?',
                    conteudo: 'Seu simulado será perdido.'
                }, self.animaSaidaSimulado);
            },
            mathJaxRender: function () {
                Vue.nextTick(function () {
                    MathJax.Hub.PreProcess( );
                    MathJax.Hub.Process( );
                });
            },
            voltarUmaQuestao: function () {
                fechaTooltips();

                if( this.questaoAtual > 1 ){
                    this.mathJaxRender();
                    return this.questaoAtual--;
                }
            },
            avancarUmaQuestao: function () {
                fechaTooltips();

                if( this.questaoAtual < this.numQuestoes ){
                    this.mathJaxRender();
                    return this.questaoAtual++;
                }
            },
            verQuestao: function ( n, fecha_indice ) {

                if( n < 1 || n > this.numQuestoes ){
                    return false;
                }

                /* Troca de questao -> guarda tempo da Q anterior e zera timer de questao */
                this.questoes[this.questaoAtual].tempo += this.tempoQuestao;
                this.tempoQuestao = 0;
                this.questoes[this.questaoAtual].textoVisivel = false;

                this.questaoAtual = n;

                fechaTooltips();
                if( fecha_indice ) this.fechaIndiceCompleto();
                this.mathJaxRender();
            },
            abreIndiceCompleto: function () {

                var self = this;
                var divIndice = $('#conteudo-indice-completo');
                var iconeAbrir = $('i.abre-indice');
                var iconeFechar = $('i.fecha-indice');
                var liHeight = 28;

                // 10 <li> (com 4px de margem) por linha + 4px no final
                var alturaDiv = Math.ceil(this.numQuestoes/10) * (liHeight + 4) + 4;

                divIndice.height(alturaDiv);
                divIndice.slideDown(400, function () {
                    iconeFechar.css({top: (alturaDiv - 10)});
                    iconeAbrir.fadeOut(200);
                    iconeFechar.fadeIn(200);
                    self.indiceAberto = true;
                });
                fechaTooltips();
            },
            fechaIndiceCompleto: function () {
                var self = this;
                $('i.fecha-indice').fadeOut(200);
                $('#conteudo-indice-completo').slideUp(400, function () {
                    $('i.abre-indice').fadeIn(200);
                    self.indiceAberto = false;
                });
                fechaTooltips();
            },
            abreFechaTexto: function ( n ) {
                this.questoes[n].textoVisivel = !this.questoes[n].textoVisivel;
                var alturaTexto = $('.texto-conteudo').height();
                var hExtra = this.questoes[n].textoVisivel ? alturaTexto : -alturaTexto;

            },
            selecionaAlternativa: function ( numero_questao, alternativa_id ) {

                if( this.questoes[numero_questao].selecionada == alternativa_id ){
                    this.questoes[numero_questao].selecionada = -1;
                }else{
                    this.questoes[numero_questao].selecionada = alternativa_id;
                }

                this.atualizaResolvidas();
            },
            atualizaResolvidas: function () {

                var qResolvidas = 0;
                for(var n in this.questoes){
                    if(this.questoes[n].selecionada != -1){
                        qResolvidas++;
                    }
                }

                this.numResolvidas = qResolvidas;
            },
            proximaOuFinalizar: function (  ) {
                if( this.questoes[this.questaoAtual].selecionada == -1 ){
                    return false;
                }

                if( (this.questoes[this.questaoAtual].numero < this.numQuestoes) &&
                    (this.numResolvidas < this.numQuestoes)
                ){
                    return 'proxima';
                }else{
                    return 'finalizar';
                }
            },
            verificaFinalizacao: function () {
                var self = this;
                if( this.numResolvidas < this.numQuestoes ){
                    confirma(
                        {
                            titulo: 'Deseja mesmo finalizar seu simulado?',
                            conteudo: 'Ainda há questões sem respostas'
                        },
                        {
                            cbSim: function () { self.finalizaSimulado(); },
                            cbNao: function () { return false; }
                        }
                    );
                }else{
                    this.finalizaSimulado();
                }
            },
            finalizaSimulado: function ( timer_zerou ) {
                var self = this;

                this.questoes[this.questaoAtual].tempo += this.tempoQuestao;
                this.tempoQuestao = 0;

                if( timer_zerou ){
                    flash('Tempo esgotado!', 'erro');
                }

                this.simuladoFinalizado = true;

                /* Faz um charme por 2 segundos */
                setTimeout(function () {

                    self.mostrandoResultados = true;

                    Vue.nextTick(function () {
                        self.geraGraficoPercentual();
                        self.geraGraficoTempo();
                    });

                }, 2000);

            },
            geraGraficoPercentual: function () {

                this.numAcertos = 0;
                for(var n in this.questoes){
                    if( this.questoes[n].selecionada == this.questoes[n].gabarito ){
                        this.numAcertos++;
                    }
                }

                var acertoPercentual = Math.round(this.numAcertos/this.numQuestoes * 100);
                var erroPercentual = 100 - acertoPercentual;

                this.dadosDesempenho.datasets[0].data = [acertoPercentual, erroPercentual];

                var grafDesemp = new Chart($('#grafico-percentual'), {
                    type: 'doughnut',
                    data: this.dadosDesempenho,
                    options: {
                        legend: {
                            display: false
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    return data.datasets[0].data[tooltipItem.index] + '% de ' +
                                        data.labels[tooltipItem.index];
                                }
                            }
                        }
                    }
                });
            },
            geraGraficoTempo: function () {

                var self = this;
                var i = 0;
                var tempoTotal = 0;
                for(var n in this.questoes){
                    this.dadosTempo.labels[i] = 'Q' + n;
                    this.dadosTempo.datasets[0].data[i] = this.questoes[n].tempo;
                    tempoTotal += this.questoes[n].tempo;
                    i++;
                }

                this.tempoMedioGasto = Math.round(tempoTotal/this.numQuestoes);

                var grafTempo = new Chart($('#grafico-tempo'), {
                    type: 'bar',
                    data: this.dadosTempo,
                    defaultfontColor: "#FFF",
                    options: {
                        legend: {
                            display: false
                        },
                        scales: {
                            yAxes: [{
                                ticks: {
                                    callback: function(value, index, values) {
                                        return value + 's';
                                    },
                                    beginAtZero: true
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function(tooltipItem, data) {
                                    return self.formataTempo(data.datasets[0].data[tooltipItem.index]);
                                }
                            }
                        }
                    }
                });
            },
            formataTempo: function ( tempoS ) {
                if( tempoS < 60 ){
                    return tempoS + 's';
                }

                if( tempoS < 60*60 ){
                    return Math.floor(tempoS/60) + 'min' + tempoS%60 + 's';
                }

                var h = Math.floor(tempoS/3600);
                var m = Math.floor((tempoS%3600)/60);
                var s = tempoS - 3600*h - 60*m;

                return h + 'h' + m + 'min' + s + 's';
            },
            mostraQuestaoGabarito: function ( numero_questao ) {

                if( this.resultadoSelecionado != -1 ){
                    this.questoes[this.resultadoSelecionado].textoVisivel = false;
                }
                
                this.resultadoSelecionado = numero_questao;
                this.mathJaxRender();
            },
            alternativaCertaErrada: function ( a_id ) {

                var selecionada = this.questoes[this.resultadoSelecionado].selecionada;
                var gabarito = this.questoes[this.resultadoSelecionado].gabarito;

                if( selecionada == -1 ){
                    return a_id == gabarito ? 'alternativa-selecionada' : '';
                }

                if( a_id == selecionada && a_id == gabarito ){
                    return 'alternativa-certa';
                }

                if( a_id == selecionada && a_id != gabarito ){
                    return 'alternativa-errada';
                }

                if( a_id != selecionada && a_id == gabarito ){
                    return 'alternativa-certa';
                }

                return '';
            },
            abreModalSair: function () {
                this.lightbox('#modal-sair-simulado');
            },
            sairSimuladoFinalizado: function ( ) {
                
                if( this.salvarNaSaida == 'sim'){
                    this.salvaResultados();
                }else{
                    this.animaSaidaSimulado();
                }

                this.lightbox.close();
            },
            salvaResultados: function ( redirecionar ) {

                var self = this;
                var resultados = [];
                for(var n in this.questoes){
                    resultados.push({
                        questao     : self.questoes[n].id,
                        tempo       : self.questoes[n].tempo,
                        marcou      : self.questoes[n].selecionada,
                        acertou     : (self.questoes[n].selecionada == self.questoes[n].gabarito) ? 1 : 0
                    });
                }

                ajaxPOST(
                    '/simulados/salva-resultados',
                    { resultados: JSON.stringify(resultados) },
                    function( retorno ) {
                        if(redirecionar){
                            window.location.replace(redirecionar);
                        }else{
                            self.animaSaidaSimulado();
                        }
                    }
                );
            },
            irPara: function ( onde ) {

                var ids = [], n, redirecionar;

                switch (onde){
                    case 'todasQuestoes':
                        for(n in this.questoes){
                            ids.push(this.questoes[n].id);
                        }
                        redirecionar = '/questoes#q=' + JSON.stringify(ids);
                        break;
                    case 'questoesErradas':
                        for(n in this.questoes){
                            if(this.questoes[n].selecionada != this.questoes[n].gabarito){
                                ids.push(this.questoes[n].id)
                            }
                        }
                        redirecionar = '/questoes#q=' + JSON.stringify(ids);
                        break;
                    case 'estatisticas':
                        redirecionar = '/painel#/simulados/1';
                        break;
                    default:
                        redirecionar = '/simulados';
                }

                this.lightbox.close();

                if( this.salvarNaSaida == 'sim'){
                    this.salvaResultados( redirecionar );
                }else{
                    window.location.replace(redirecionar);
                }

            },
            verificaHash: function ( hash ) {

                if( (hash == '#passo1' && this.passoAtual == 2) ||
                    (hash == '#passo2' && this.passoAtual == 3)
                ){
                    return this.prev();
                }else if( (hash == '#passo2' && this.passoAtual == 1) ||
                    (hash == '#passo3' && this.passoAtual == 2)
                ){
                    return this.next();
                }else if( hash.substring(0, 7) == '#prova=' ){

                    var provaId = parseInt(hash.substring(7));

                    if( isNaN(provaId) ){
                        flash('ID de prova inválido!', 'erro');
                        return location.hash = '#passo' + this.passoAtual;
                    }

                    this.gerarSimulado( provaId );

                }else if( !hash ){
                    location.hash = '#passo' + this.passoAtual;
                }else if( hash == '#modo-simulado'){
                    // FAZER ALGO? Acho que não...
                } else {
                    location.hash = '#passo' + this.passoAtual;
                }

            }
        },
        computed: {
            progresso: function () {

                var progresso = Math.ceil(this.numResolvidas/this.numQuestoes * 100);

                $('#progresso').animate({ width: progresso + "%"}, 500);

                return progresso;
            },
            anosAte: function () {

                var a = [];

                for(var i in this.anos){
                    if( this.anos[i] >= this.filtros.desde ){
                        a.push(this.anos[i]);
                    }
                }
                return a;
            },
            arrayNumQuestoes: function () {

                /* Modelo (3 itens antes, 3 depois): */
                /* < 1 | 2 | 3 | (4) | 5 | 6 | 7 > */

                var qInicial = 1;
                var qFinal = 7;

                if( (this.questaoAtual > 4) && (this.questaoAtual + 3 <= this.numQuestoes) ){
                    qInicial = this.questaoAtual - 3;
                    qFinal = this.questaoAtual + 3;
                }

                if( (this.questaoAtual > 4) && (this.questaoAtual + 3 > this.numQuestoes) ){
                    qInicial = this.questaoAtual - 6 + (this.numQuestoes - this.questaoAtual);
                    qFinal = this.numQuestoes;
                }

                var nq = [];
                for(var i = qInicial; i<= qFinal; i++)
                {
                    nq.push(i);
                }

                return nq;
            }
        },
        created: function () {

            MathJax.Hub.Config({
                showProcessingMessages: false,
                messageStyle: 'none'
            });

            var self = this;
            var hash = location.hash;
            this.verificaHash( hash );

            ajaxGET('simulados/carregamento-inicial', {}, function (dados) {
                self.areasConhecimento = dados.areasConhecimento;
                self.anos = dados.anos;
                self.logado = dados.logado;
            });
        }
    });

    /* SIMPLE JAVASCRIT ROUTER - BY RONI RIGONI */
    $(window).on('hashchange', function () {

        vmSimulados.verificaHash(location.hash);
    });

    /* Sempre que selecionar/desselecionar uma area => atualiza areasSelecionadas[] */
    vmSimulados.$watch('areasConhecimento', function () {
        var areasSelecionadas = [];

        for(var areaId in this.areasConhecimento){
            if( this.areasConhecimento[areaId].selecionado ){
                areasSelecionadas.push(areaId);
            }
        }
        this.modificouAreas = true;

        this.areasSelecionadas = areasSelecionadas;
    }, {deep: true});


    /* Sempre que selecionar/desselecionar uma disciplina => atualiza disciplinasSelecionadas[] */
    vmSimulados.$watch('arvore', function () {
        var disciplinasSelecionadas = [];
        var questoesDisponiveis = 0, disciplina;

        for(var areaId in this.arvore){
            for(var discId in this.arvore[areaId].disciplinas){
                disciplina = this.arvore[areaId].disciplinas[discId];
                if( disciplina.selecionado ){
                    disciplinasSelecionadas.push(discId);
                    questoesDisponiveis += disciplina.questoes;
                }
            }
        }
        this.modificouDisciplinas = true;

        this.disciplinasSelecionadas = disciplinasSelecionadas;
        this.questoesDisponiveis = questoesDisponiveis;
    }, {deep: true});


    /* Se mudar o ano 'desde' de modo que 'desde' > 'ate', então fazemos 'ate' = 'desde' */
    vmSimulados.$watch('filtros.desde', function () {
        if( (this.filtros.ate < this.filtros.desde) && (this.filtros.ate != -1) ){
            this.filtros.ate = this.filtros.desde;
        }
    });

}
